import { Spherical } from 'three';
import { RAD2DEG } from 'three/src/math/MathUtils';


const getVecX = (vec) => (vec.isVector3 ? vec.x : vec[0]);
const getVecY = (vec) => (vec.isVector3 ? vec.y : vec[1]);
const getVecZ = (vec) => (vec.isVector3 ? vec.z : vec[2]);

export const getSphericalCoordsFromPositionTarget = (position, target) => {
  const deltaX = getVecX(position) - getVecX(target);
  const deltaY = getVecY(position) - getVecY(target);
  const deltaZ = getVecZ(position) - getVecZ(target);

  const sphericalCoords = new Spherical().setFromCartesianCoords(deltaX, deltaY, deltaZ);
  const distance = sphericalCoords.radius;
  const verticalAngleDeg = 90 - sphericalCoords.phi * RAD2DEG;
  const horizontalAngleDeg = sphericalCoords.theta * RAD2DEG;

  return {
    distance, verticalAngleDeg, horizontalAngleDeg
  }
}
